/**
 * Product Helper Functions
 * Utilities for handling product data
 */

/**
 * Get rating value from product.rating (handles both number and object formats)
 * FakeStore API returns rating as: { rate: 4.5, count: 120 }
 * Our format uses: number or { rating: number, ratingCount: number }
 */
export const getRatingValue = (rating) => {
  if (!rating) return 0;
  if (typeof rating === 'number') return rating;
  if (typeof rating === 'object' && rating.rate !== undefined) return rating.rate;
  if (typeof rating === 'object' && rating.rating !== undefined) return rating.rating;
  return 0;
};

/**
 * Get rating count from product.rating
 */
export const getRatingCount = (rating, ratingCount) => {
  if (ratingCount) return ratingCount;
  if (!rating) return 0;
  if (typeof rating === 'object' && rating.count !== undefined) return rating.count;
  if (typeof rating === 'object' && rating.ratingCount !== undefined) return rating.ratingCount;
  return 0;
};

/**
 * Render star rating display
 */
export const renderStars = (rating) => {
  const ratingValue = getRatingValue(rating);
  const rounded = Math.round(ratingValue);
  return '★'.repeat(rounded) + '☆'.repeat(5 - rounded);
};

/**
 * Format price (handles both string and number)
 */
export const formatPrice = (price) => {
  if (price === null || price === undefined) return '0.00';
  const numPrice = typeof price === 'string' ? parseFloat(price) : price;
  return numPrice.toFixed(2);
};

